export const host = process.env.REACT_APP_API_URL;

export const PAGINATION = {
    DEFAULT_PAGE_SIZE: 16,
    SERIALS_PAGE_SIZE: 16,
    FRANCHISES_PAGE_SIZE: 16
};